// FeedbackDialog.js - Einfacher Feedback-Dialog nach Speichern
import React from 'react';
import Dialog from './Dialog';

const FeedbackDialog = ({ isOpen, onClose, message }) => (
  <Dialog
    isOpen={isOpen}
    onClose={onClose}
    title="Erfolg"
    size="sm"
    actions={[
      <button
        key="ok"
        className="bg-primary text-white px-4 py-2 rounded hover:bg-primaryDark"
        onClick={onClose}
      >
        OK
      </button>
    ]}
  >
    <div className="text-center text-lg py-4">{message}</div>
  </Dialog>
);

export default FeedbackDialog;